/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Ai_Actions_75Inputs */

const en_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI actions / month`)
};

const de_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 KI-Aktionen / Monat`)
};

const fr_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 actions IA / mois`)
};

const es_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 acciones IA / mes`)
};

const it_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 azioni IA / mese`)
};

const nl_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-acties / maand`)
};

const pl_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 akcji AI / miesiac`)
};

const fi_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-toimintoa / kuukausi`)
};

const da_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-handlinger / maned`)
};

const sv_pricing_feature_ai_actions_75 = /** @type {(inputs: Pricing_Feature_Ai_Actions_75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-handlingar / manad`)
};

/**
* | output |
* | --- |
* | "75 AI actions / month" |
*
* @param {Pricing_Feature_Ai_Actions_75Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_ai_actions_75 = /** @type {((inputs?: Pricing_Feature_Ai_Actions_75Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Ai_Actions_75Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_ai_actions_75(inputs)
	if (locale === "fr") return fr_pricing_feature_ai_actions_75(inputs)
	if (locale === "es") return es_pricing_feature_ai_actions_75(inputs)
	if (locale === "it") return it_pricing_feature_ai_actions_75(inputs)
	if (locale === "nl") return nl_pricing_feature_ai_actions_75(inputs)
	if (locale === "pl") return pl_pricing_feature_ai_actions_75(inputs)
	if (locale === "fi") return fi_pricing_feature_ai_actions_75(inputs)
	if (locale === "da") return da_pricing_feature_ai_actions_75(inputs)
	if (locale === "sv") return sv_pricing_feature_ai_actions_75(inputs)
	return en_pricing_feature_ai_actions_75(inputs)
});